import { Space, Typography } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useUserPermissions } from "~context/UserPermissionsContext";
import { PermissionNames, PermissionOperations } from "~enums/permissions.ts";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import FixturePlayByPlayFlaggedEventDataTable from "~pages/Reports/components/FixturePlayByPlayFlaggedEventDataTable/FixturePlayByPlayFlaggedEventDataTable.tsx";
import { GenerateReportButton } from "~pages/Reports/components/GenerateReportButton/GenerateReportButton.tsx";

const SeasonReportsPage = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();
  const { uiConfiguration } = useSportConfiguration();
  const reportsConfig = uiConfiguration?.pages?.reports.reportsConfig || [];
  const { hasPermission } = useUserPermissions();

  const hasPermissionToViewReports = hasPermission(PermissionNames.REPORT, PermissionOperations.READ);
  const hasPermissionToViewFlaggedEvents = hasPermission(PermissionNames.FIXTURE_PLAY_BY_PLAY, PermissionOperations.READ);

  return (
    <Space direction={"vertical"} size={24} style={{ width: "100%" }}>
      <Typography.Title level={2}>{formatMessage({ id: "reports" })}</Typography.Title>
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Space size={20} style={{ height: "100%", alignItems: "stretch" }}>
          {hasPermissionToViewReports &&
            reportsConfig.map((reportConfig) => (
              <GenerateReportButton
                titleIntlKey={reportConfig.titleIntlKey}
                descriptionIntlKey={reportConfig.descriptionIntlKey}
                url={reportConfig.generateReportUrl(sport || "", organizationId || "", seasonId || "")}
                key={reportConfig.key}
                notificationMessageIntlKey={reportConfig.notificationMessageIntlKey}
              />
            ))}
        </Space>
        {hasPermissionToViewFlaggedEvents && <FixturePlayByPlayFlaggedEventDataTable />}
      </Space>
    </Space>
  );
};

export default SeasonReportsPage;
